module.exports = "https://static.wagwalking.com/_next/static/images/badge-trusted-2af391c40abb562e3465f9b9f39121ef.svg";